import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { REQUEST_PASSWORD_RESET } from '../graphql/mutations'
import toast from 'react-hot-toast'
import { Input } from '../components/ui/Input'
import { Button } from '../components/ui/Button'

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  // The API always returns true (no email enumeration), so the page always
  // shows the same confirmation regardless of whether the account exists.
  const [requestReset, { loading }] = useMutation(REQUEST_PASSWORD_RESET, {
    onCompleted: () => setSubmitted(true),
    onError: () => setSubmitted(true),
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) {
      toast.error('Please enter your email address')
      return
    }
    requestReset({ variables: { email: email.trim() } })
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-seasalt py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center">
            <img src="/brand/logo.svg" alt="Curry Me POS" className="h-14 w-auto" />
          </div>
          <h2 className="mt-6 text-center font-primary text-h4 font-bold text-secondary-900">
            Forgot password
          </h2>
          <p className="mt-2 text-center text-body text-secondary-600">
            Enter your email address and we'll send you a reset link
          </p>
        </div>

        {submitted ? (
          <div className="text-center space-y-6">
            <p className="text-body text-secondary-700">
              If an account exists for this email, a password reset link has been sent.
              The link is valid for 1 hour.
            </p>
            <Link to="/login" className="text-primary-600 hover:text-primary-700 font-medium">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="rounded-lg"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>

            <Button type="submit" isLoading={loading} className="w-full" size="lg">
              Send reset link
            </Button>

            <p className="text-center">
              <Link to="/login" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  )
}

export default ForgotPasswordPage
